/**
 * We shouldn't really need this file, as the editor shouldn't require us to pass in
 * a task and decision provider. But for now it does. So this whole thing is a stub.
 */

import type { MemoizedFn } from 'memoize-one';
import memoizeOne from 'memoize-one';

import type {
	RecentUpdateContext,
	ObjectKey,
	Handler,
	TaskState,
	RecentUpdatesId,
	TaskDecisionProvider,
} from '@atlaskit/task-decision/types';

export type TaskDecisionProviderType = TaskDecisionProvider;

type ToggleTaskCallback = (objectKey: ObjectKey, state: TaskState) => void;

class Provider {
	_toggleTaskCallback: ToggleTaskCallback | undefined;

	constructor(toggleTask?: ToggleTaskCallback) {
		this._toggleTaskCallback = toggleTask;
	}

	notifyRecentUpdates(_updateContext: RecentUpdateContext): void {}

	subscribe(_objectKey: ObjectKey, _handler: Handler): void {}

	toggleTask(objectKey: ObjectKey, state: TaskState): Promise<TaskState> {
		if (this._toggleTaskCallback) {
			this._toggleTaskCallback(objectKey, state);
		}
		return Promise.resolve(state);
	}

	unsubscribe(_objectKey: ObjectKey, _handler: Handler): void {}

	unsubscribeRecentUpdates(_id: RecentUpdatesId): void {}
}

// have to use memoizeOne because getTaskDecisionProvider is used in classic EditorComponent
export const getTaskDecisionProvider: MemoizedFn<
	(toggleTaskCallback?: ToggleTaskCallback) => Promise<Provider>
> = memoizeOne(async (toggleTaskCallback?: ToggleTaskCallback): Promise<Provider> => {
	return new Provider(toggleTaskCallback);
});
